import { useState, useEffect, useRef } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import PostReq from "../../../utils/PostReq";
import env from "../../../env";

function ProductMaster(props) {
  const [mainProduct, setMainProduct] = useState("");
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const debounceRef = useRef(null);
  const requestIdRef = useRef(0);

  useEffect(() => {
    // اگر کمتر از 3 کاراکتر است، از لیست اولیه استفاده کن
    if (!inputValue || inputValue.length < 3) {
      setOptions([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      const thisRequestId = ++requestIdRef.current;
      try {
        const result = await PostReq({
          method: "post",
          url: "/panel/product/list-master",
          body: { title: inputValue },
        });

        // فقط اگر این پاسخ آخرین درخواست باشد اعمال شود
        if (thisRequestId === requestIdRef.current) {
          setOptions(Array.isArray(result.filter) ? result.filter : []);
          setLoading(false);
        }
      } catch (err) {
        if (thisRequestId === requestIdRef.current) {
          console.error(err);
          setOptions([]);
          setLoading(false);
        }
      }
    }, 450);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [inputValue, props.masterList]);

  const setMainSlave = async () => {
    const body = {
      master: mainProduct,
      products: props.selectItems,
    };

    try {
      await PostReq({
        method: "post",
        url: "/panel/product/update-to-master",
        body,
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={(option, value) =>
          (option && option.sku) === (value && value.sku)
        }
        onChange={(event, value) => setMainProduct(value ? value.sku : "")}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        loading={loading}
        sx={{ minWidth: 250 }}
        noOptionsText={
          inputValue.length < 3 ? "حداقل ۳ کاراکتر وارد کنید" : "موردی یافت نشد"
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="محصول اصلی"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      <div className="edit-btn add-btn" onClick={setMainSlave}>
        <i className="fa-solid fa-refresh"></i>
        <p>همگام سازی اطلاعات</p>
      </div>
    </>
  );
}

export default ProductMaster;
